import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Memo from "@/pages/Memo";
import Pratiche from "@/pages/Pratiche";
import PraticaDetail from "@/pages/PraticaDetail";
import Documenti from "@/pages/Documenti";
import Contatti from "@/pages/Contatti";
import Fatturazione from "@/pages/Fatturazione";
import Email from "@/pages/Email";
import Ricerca from "@/pages/Ricerca";
import Report from "@/pages/Report";
import AIAssistant from "@/pages/AIAssistant";
import Impostazioni from "@/pages/Impostazioni";
import Automazioni from "@/pages/Automazioni";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-navy-800" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/memo" element={<Memo />} />
              <Route path="/pratiche" element={<Pratiche />} />
              <Route path="/pratiche/:id" element={<PraticaDetail />} />
              <Route path="/documenti" element={<Documenti />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/fatturazione" element={<Fatturazione />} />
              <Route path="/email" element={<Email />} />
              <Route path="/ricerca" element={<Ricerca />} />
              <Route path="/report" element={<Report />} />
              <Route path="/ai" element={<AIAssistant />} />
              <Route path="/impostazioni" element={<Impostazioni />} />
              <Route path="/automazioni" element={<Automazioni />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
